<!--
 * @Author: lijh(¯﹃¯*)
 * @Date: 2023-12-12 09:55:58
 * @LastEditors: lijh(¯﹃¯*)
 * @LastEditTime: 2024-03-06 18:08:56
 * @Description: 病例讨论详情页
-->
<template>
  <div class="forum-list">
    <div class="forum-list-content">
      <detail-header
        title="病例讨论"
        icon="icon-line-discusstaolun"
        :iconStyle="iconStyle"
        :tip="forumTips"
        @back="back"
      ></detail-header>
      <div class="container-body" v-loading="data.tableLoading">
        <detail-form
          :showPublishButton="true"
          :showReviewButton="deptPower"
          @search="handleClickSearch"
          @showTypeQuery="showTypeQuery"
        ></detail-form>

        <div v-show="showDataType === '-1'">
          <div class="forum-panel">
            <el-row :gutter="20">
              <el-col :span="24">
                <el-col :span="span" v-show="!unApproveMember">
                  <!--病例讨论-->
                  <div class="forum-card-create">
                    <span class="forum-card-create-up"></span>
                    <span class="forum-card-create-center">
                      <span>新增讨论组</span>
                      <span>填写讨论组简介</span>
                    </span>
                    <span class="forum-card-create-bottom">
                      <button class="btn-start" @click="startNewForum">
                        发起讨论
                      </button>
                    </span>
                  </div>
                </el-col>
                <div v-for="(item, index) of caseDiscussEs" :key="index">
                  <el-col :span="span">
                    <!--病例讨论-->
                    <div
                      class="forum-card-apply"
                      :key="index"
                      @click="intoCaseDiscuss(item)"
                    >
                      <!--卡片底部的面板div-->
                      <div
                        class="forum-card-apply-up"
                        :style="`background-color:${forumColors[index % 10]}`"
                      ></div>
                      <!--下面的大内容-->
                      <div class="forum-card-apply-down">
                        <div class="forum-card-top">
                          <span
                            class="forum-card-avatar"
                            :style="
                              `background-image: url(${avatarPre}/${item.avatar})`
                            "
                          ></span>
                        </div>
                        <div class="forum-card-inner">
                          <span class="forum-card-title">
                            <span>{{ item.postTitle }}</span>
                          </span>
                          <span class="forum-card-content">{{
                            item.postContent | filterContext
                          }}</span>
                          <span
                            class="forum-card-author icon-caidanguanli iconfont"
                            >发起人：{{ item.userName }}</span
                          >
                          <span class="forum-card-time icon-rili iconfont">{{
                            item.createTm | datetimeFormat
                          }}</span>
                        </div>
                        <div class="forum-card-bottom">
                          <button
                            class="btn-apply"
                            @click.stop="applyHandler(item)"
                            v-if="!item.postContent && item.status == '1'"
                          >
                            申请加入
                          </button>
                          <button
                            class="btn-share"
                            @click.stop="shareDiscuss(item)"
                            v-if="item.status == '1'"
                          >
                            分享讨论
                          </button>
                        </div>
                      </div>
                    </div>
                  </el-col>
                </div>
              </el-col>
            </el-row>
          </div>

          <div
            id="loadingTipText"
            title="点击加载更多"
            @click="lazyLoadingData(0)"
          >
            {{ loadingText }}
          </div>
        </div>

        <div v-show="showDataType !== '-1'" class="table-card">
          <detail-table
            :data="tableData"
            :columns="tableColumns"
            height="calc(100vh - 380px)"
            :header-cell-style="headerCellStyle"
            :row-style="tableRowClassName"
            :showBorder="false"
            showOperator
            operatorWidth="150"
            @sort-change="sort_change"
          >
            <template #createTm="{scope}">
              <span>{{ scope.row.createTm | dateFormat }}</span>
            </template>
            <template #status="{scope}">
              <span>{{ scope.row.status | computedArticleStatus }}</span>
            </template>

            <template #default="{scope}">
              <button
                type="button"
                class="eims-button"
                @click.stop="discussView(scope.row)"
              >
                查看
              </button>
              <button
                type="button"
                v-if="computedShowEdit(scope.row)"
                class="eims-button"
                @click.stop="handleEditDiscuss(scope.row)"
              >
                编辑
              </button>
              <button
                type="button"
                v-if="computedShowDelete(scope.row) && scope.row.status !== '1'"
                class="eims-button"
                @click.stop="discussDelete(scope.row)"
              >
                删除
              </button>
            </template>
          </detail-table>
        </div>
        <div class="page" v-if="showDataType !== '-1'">
          <el-pagination
            layout="sizes, prev, pager, next"
            :total="data.list.length"
            :page-size="data.pageSize"
            :page-sizes="data.pageSizeArray"
            @current-change="handlePageChange"
            @size-change="handleSizeChange"
            :current-page.sync="data.pageNum"
          >
          </el-pagination>
        </div>
      </div>

      <div id="toBigDiv"></div>

      <div
        id="showScroll"
        class="icon-huidaodingbu iconfont"
        title="回到顶部"
        @click="scrollToTop"
      ></div>

      <post-create
        ref="forum-create"
        :base-url="baseUrl"
        title="发布病例讨论"
        :visible.sync="postCreateVisible"
        :has-attachment="true"
        :has-members="true"
        :tips="forumTips"
        :member-tips="true"
        :showProtocol="true"
        @sensitiveWord="sensitiveWord"
      />

      <el-dialog
        title="申请提示"
        :visible.sync="applyDialogVisible"
        center
        width="30%"
      >
        <span>是否向发布者申请加入？</span>
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="applyDialogVisible = false"
            type="info"
            size="small"
            >取 消</el-button
          >
          <el-button @click="sureApplyHandler" type="primary" size="small"
            >确 定</el-button
          >
        </span>
      </el-dialog>

      <!--加载动画-->
      <animation
        :loadingDataVisible="isLoading"
        loadingText="提交中"
      ></animation>

      <post-detail
        v-if="postDetailVisible"
        :baseUrl="baseUrlDetail"
        :status="dialog.status"
        :tp-code="dialog.postTpCode"
        :post-code="dialog.postCode"
        @handlerVisible="handlerVisible"
      />

      <post-update
        v-if="postUpdateVisible"
        title="修改病例讨论"
        :hasMembers="true"
        :baseUrl="baseUrlDetail"
        :baseUrlUpdate="baseUrlUpdate"
        :hasAttachment="true"
        :post-code="dialog.postCode"
        :status="dialog.status"
        :post-tp-code="dialog.postTpCode"
        @refresh="queryData"
        @sensitiveWord="sensitiveWord"
        @handlerVisible="handlerVisible"
      />

      <post-approve
        :row="dialog"
        :visible.sync="postApproveVisible"
        :btnFlag="deptPower"
        @refresh="queryData"
      ></post-approve>
    </div>
  </div>
</template>

<script>
import { generateStandardSpan } from "@/utils/acquireStandardSpan";
import { Message } from "element-ui";
import { mapState } from "vuex";
import { articleMixin } from "../mixins/articleMixin";
import { PAGE_SIZE_ARRAY } from "@/constants/constants";
import scrollbarWidth from "element-ui/src/utils/scrollbar-width";
import http from "@/utils/axios";
import cookie from "@/utils/cookie";
import ForumDetail from "@/components/detail/ForumDetail";
import animation from "@/components/loading/animation";
import PostDetail from "../../components/detail/PostDetail";
import PostUpdate from "../../components/detail/PostUpdate";
import PostApprove from "../../components/detail/PostApprove";
import PostCreate from "../../components/detail/PostCreate";
import DetailHeader from "@/components/common/DetailHeader";
import DetailForm from "@/components/common/DetailForm";
import DetailTable from "@/components/common/DetailTable";

export default {
  name: "ForumList",

  mixins: [articleMixin],

  components: {
    PostApprove,
    PostUpdate,
    PostDetail,
    PostCreate,
    ForumDetail,
    animation,
    DetailHeader,
    DetailForm,
    DetailTable
  },

  data() {
    return {
      isLoading: false,
      applyForum: {},
      applyDialogVisible: false,
      //懒加载是否完成
      lazyLoadingFinally: true,
      scrollTopStep: 10,
      avatarPre: window.config.avatar.baseUrl,
      caseDiscussEs: [],
      //节流
      spanTimeout: null,
      keywordTimeout: null,
      span: 6,
      loading: { flag: true },
      loadingText: "下拉或点击加载更多数据",
      count: 0,
      keyword: null,
      //每次加载多少条数据
      step: 10,
      //矫正卡片加载个数,尽量使用页面个数平齐
      revise: 0,
      //设置宽度的灵敏度
      sensitive: 320,
      //准备的颜色的数组
      forumColors: [
        "#55a7f4",
        "#ff526e",
        "#fbaf57",
        "#5ed985",
        "#7772ec",
        "#5ed5d9",
        "#1e90ff",
        "#a29bfe",
        "#be2edd",
        "#3742fa"
      ],

      baseUrl: "/eims-api/discuss/create",
      baseUrlDetail: "/eims-api/discuss/detail",
      baseUrlUpdate: "/eims-api/user/personal/article/update",
      postCreateVisible: false,
      postDetailVisible: false,
      postUpdateVisible: false,
      postApproveVisible: false,
      showDataType: "-1",

      dialog: {
        isShow: false,
        postCode: null,
        editFlag: "view",
        postTpCode: "",
        status: ""
      },
      iconStyle: {
        "font-size": "24px",
        color: "rgb(52, 212, 238)",
        margin: "0 5px"
      },

      data: {
        list: [],
        tableLoading: false,
        pageNum: 1,
        pageSize: 10,
        pageSizeArray: PAGE_SIZE_ARRAY,
        ARTICLE_DISCUSS_TYPE_CODE: "044-004",
        userId: null,
        sortProp: "createTm",
        sortOrder: "desc"
      },

      form: {
        keyword: null,
        timeRange: []
      },

      //查询时间范围
      queryTimeRange: [],

      oneSelfPublishVisible: false,
      unApprovePublishVisible: false,
      searchPublishVisible: false,

      currentHeight: null
    };
  },

  computed: {
    ...mapState({
      deptPower: state => state.userPowerStore.deptPower,
      unApproveMember: state => state.userPowerStore.unApproveMember
    }),
    //计算表格需要的高度
    calculateTableHeight() {
      //67卡片头部 104 关键词 按钮卡片大小 40上下外边距 69红砖智库红框高度 10是all-table-wrapper的margin 后面的10不知道是啥
      let result = this.currentHeight - 67 - 104 - 40 - 69 - 40 - 10 - 10;
      let defaultHeight = 250;
      if (result >= defaultHeight) {
        return result;
      } else {
        return defaultHeight;
      }
    },
    tableData() {
      return this.data.list.slice(
        (this.data.pageNum - 1) * this.data.pageSize,
        this.data.pageNum * this.data.pageSize
      );
    },
    tableColumns() {
      let arr = [];
      if (this.showDataType === "0") {
        arr = [
          {
            label: "标题",
            prop: "postTitle",
            align: "left",
            width: "auto",
            sortable: true
          },
          {
            label: "发布时间",
            prop: "createTm",
            align: "left",
            width: "200",
            showSlot: true,
            sortable: true
          },
          {
            label: "状态",
            prop: "status",
            align: "left",
            width: "150",
            showSlot: true,
            sortable: true
          },
          {
            label: "审核人",
            prop: "approveUserName",
            align: "left",
            width: "150",
            sortable: true
          }
        ];
      } else if (this.showDataType === "1") {
        arr = [
          {
            label: "标题",
            prop: "postTitle",
            align: "left",
            width: "auto",
            sortable: true
          },
          {
            label: "发布时间",
            prop: "createTm",
            align: "left",
            width: "200",
            showSlot: true,
            sortable: true
          },
          {
            label: "状态",
            prop: "status",
            align: "left",
            width: "150",
            showSlot: true,
            sortable: true
          },
          {
            label: "申请人",
            prop: "userName",
            align: "left",
            width: "150",
            sortable: true
          },
          {
            label: "单位",
            prop: "departmentName",
            align: "left",
            width: "150",
            sortable: true
          }
        ];
      }
      return arr;
    }
  },

  watch: {
    "data.list.length": {
      handler(newVal, oldVal) {
        if (newVal < oldVal) {
          if (oldVal === 1) {
            if (this.data.pageNum !== 1) {
              this.handlePageChange(this.data.pageNum - 1);
            } else {
              this.handlePageChange(1);
            }
          }
        }
      }
    },

    //点击选择选中不同身份显示的文章
    showDataType: {
      handler(newVal) {
        //移除监听事件
        if (newVal !== "-1") {
          window.removeEventListener("resize", this.timeOutChange);
          window.removeEventListener("scroll", this.scroll);
          //重新绑定
        } else {
          window.addEventListener("resize", this.timeOutChange);
          window.addEventListener("scroll", this.scroll);
          this.$nextTick(args => {
            this.initPage();
          });
        }
        //切换卡片的动画执行的关键
      }
    },

    keyword(newVal) {
      this.$store.dispatch("setDiscussCondition", { keyword: this.keyword });

      if (this.keywordTimeout) {
        clearTimeout(this.keywordTimeout);
        this.keywordTimeout = null;
      }
      this.keywordTimeout = setTimeout(() => {
        this.count = this.$options.data().count;
        this.caseDiscussEs = [];
        this.lazyLoadingData();
      }, 400);
    },

    loading: {
      deep: true,
      handler(newVal) {
        if (this.showDataType === "-1") {
          let dom = document.getElementById("loadingTipText");
          if (newVal.flag) {
            dom.classList.add("loadingText");
            this.loadingText = "正在加载更多数据";
          } else {
            this.loadingText = "已经没有更多数据了";
            dom.classList.remove("loadingText");
          }
        }
      }
    },
    span(newVal) {
      this.step = (24 / newVal) * 5;
      this.revise = 24 / newVal - ((this.count + 1) % (24 / newVal));
    }
  },

  mounted() {
    this.$nextTick(args => {
      //获取当前屏幕的高度
      this.currentHeight = document.body.offsetHeight;
    });
    if (this.$route.query.flag) {
      this.showDataType = this.$route.query.flag;
    } else {
      this.showDataType = "-1";
    }

    if (this.showDataType !== "-1") {
      this.queryData();
    }

    this.$nextTick(args => {
      this.initPage();
    });
  },

  //销毁时销毁监听器
  beforeDestroy() {
    window.removeEventListener("resize", this.timeOutChange);
    window.removeEventListener("resize", this.calculateHeight);
    window.removeEventListener("scroll", this.scroll);
  },

  beforeRouteUpdate(to, from, next) {
    next();
    if (to.query.flag) {
      this.showDataType = to.query.flag;
    }
    this.$nextTick(args => {
      this.data.pageNum = this.$options.data().data.pageNum;
      this.data.list = this.$options.data().data.list;
      this.data.total = this.$options.data().data.total;
      this.queryData();
    });
  },

  methods: {
    //-1显示全部，0显示自己发布的，1显示未审核的(管理员显示)
    showTypeQuery(type) {
      if (type === "add") {
        this.handleClickAdd();
      } else {
        if (this.showDataType !== type) {
          this.showDataType = type;
          this.data.pageNum = this.$options.data().data.pageNum;
          this.data.list = this.$options.data().data.list;
          this.data.total = this.$options.data().data.total;
          this.$router.push({
            path: this.$route.path,
            query: {
              flag: this.showDataType
            }
          });
        } else {
          this.queryData();
        }
      }
    },
    //分页
    handlePageChange(val) {
      this.data.pageNum = val;
      // this.queryData();
    },

    handleSizeChange(val) {
      this.data.pageSize = val;
      // this.queryData();
    },
    discussView(row) {
      if (this.showDataType === "0") {
        this.discussPrev(row);
      } else if (this.showDataType === "1") {
        this.discussPrevExp(row);
      }
    },
    discussPrev(row) {
      if (row.status === "1") {
        this.$router.push({
          path: "/forum/detail",
          query: {
            id: row.postCode
          }
        });
      } else {
        this.$router.push({
          path: "/forum/detail",
          query: {
            id: row.postCode,
            tmp: "1"
          }
        });
      }
    },

    discussPrevExp(row) {
      if (row) {
        this.dialog.postCode = row.postCode;
        this.dialog.postTpCode = row.postTpCode;
        this.$router.push({
          path: "/forum/list",
          query: {
            flag: "1"
          }
        });
      }
      if (this.showDataType === "1") {
        this.baseUrlDetail = "/eims-api/share/approve/findById";
        this.postApproveVisible = true;
      }

      this.border = true;
      this.dialog.editFlag = "view";
    },
    handleEditDiscuss(row) {
      if (this.showDataType === "-1") {
        this.baseUrlDetail = "/eims-api/discuss/detail";
      } else if (this.showDataType === "0" || this.showDataType === "2") {
        this.baseUrlDetail = "/eims-api/user/personal/article/detail";
      } else if (this.showDataType === "1") {
        this.baseUrlDetail = "/eims-api/share/approve/findById";
      }

      this.postUpdateVisible = true;
      this.border = false;
      this.dialog.editFlag = "update";
      this.dialog.postCode = row.postCode;
      this.dialog.postTpCode = row.postTpCode;
      this.dialog.status = row.status;
    },

    deleteArticle(row) {
      let obj = {
        token: cookie.getCookie("token"),
        data: {
          postCode: row.postCode,
          postTpCode: row.postTpCode,
          status: row.status
        }
      };
      http
        .post(
          window.config.api.baseUrl + "/eims-api/user/personal/article/delete",
          obj
        )
        .then(response => {
          if (response.data.code === "00000") {
            Message.success("文章信息删除成功");
          }
        })
        .finally(() => {
          this.queryData();
        });
    },

    deleteLoudSpeakerId(row) {
      let obj = {
        token: cookie.getCookie("token"),
        data: {
          dlbId: row.postCode
        }
      };
      http
        .post(window.config.api.baseUrl + "/eims-api/discuss/delete", obj)
        .then(response => {
          if (response.data.code === "00000") {
            Message.success("大喇叭文章信息删除成功");
          }
        })
        .finally(() => {
          this.queryData();
        });
    },

    discussDelete(row) {
      let that = this;
      that
        .$confirm("确定将" + row.postTitle + "删除？", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          if (this.showDataType === "-1") {
            this.deleteLoudSpeakerId(row);
          } else if (this.showDataType === "0" || this.showDataType === "2") {
            this.deleteArticle(row);
          } else if (this.showDataType === "1") {
            // this.baseUrlDetail = '/eims-api/share/approve/findById'
          }
        })
        .catch(() => {});
    },

    //查询
    handleClickSearch(form) {
      this.form = { ...this.form, ...form };
      this.data.pageNum = 1;
      this.queryData();
    },

    handlerVisible(flag) {
      this.postCreateVisible = flag;
      this.postDetailVisible = flag;
      this.postUpdateVisible = flag;
    },

    queryData() {
      //处理时间格式问题
      if (this.form.timeRange) {
        this.queryTimeRange[0] = this.form.startTm
          ? this.moment(this.form.startTm).format("YYYY-MM-DD")
          : null;
        this.queryTimeRange[1] = this.form.endTm
          ? this.moment(this.form.endTm).format("YYYY-MM-DD")
          : null;
        this.startTm = this.form.startTm
          ? this.moment(this.form.startTm).format("YYYY-MM-DD")
          : null;
        this.endTm = this.form.endTm
          ? this.moment(this.form.endTm).format("YYYY-MM-DD")
          : null;
      } else {
        this.queryTimeRange[0] = null;
        this.queryTimeRange[1] = null;
      }

      if (this.showDataType === "-1") {
        this.queryAllPublish();
      } else if (this.showDataType === "0") {
        this.queryOneself(true);
      } else if (this.showDataType === "1") {
        if (this.deptPower) {
          this.queryUnApprove();
        }
      } else if (this.showDataType === "2") {
        this.queryOneself(false);
      }
    },

    //查询自己所有的数据,包括草稿/未审核/审核通过/审核拒绝
    queryOneself(flag) {
      this.data.tableLoading = true;
      let obj = {
        token: cookie.getCookie("token"),
        data: {
          // pageNum: this.data.pageNum,
          // pageSize: this.data.pageSize,
          status: "-1",
          mySelf: flag,
          keyword: this.form.keyword,
          timeRange: this.queryTimeRange,
          startTm: this.startTm,
          endTm: this.endTm,
          postTpCode: this.data.ARTICLE_DISCUSS_TYPE_CODE
          // sortProp: this.data.sortProp,
          // sortOrder: this.data.sortOrder,
        }
      };
      http
        .post(
          window.config.api.baseUrl + "/eims-api/user/personal/article/list",
          obj
        )
        .then(value => {
          if (value.data.code === "00000") {
            this.data.list = value.data.data.approves;
            this.data.total = value.data.data.total;
            this.data.userId = value.data.data.userId;
          }
        })
        .finally(() => {
          this.data.tableLoading = false;
        });
    },

    //查询所有未审核的数据
    queryUnApprove() {
      this.data.tableLoading = true;
      let obj = {
        token: cookie.getCookie("token"),
        data: {
          // pageNum: this.data.pageNum,
          // pageSize: this.data.pageSize,
          keyword: this.form.keyword,
          timeRange: this.queryTimeRange,
          startTm: this.startTm,
          endTm: this.endTm,
          status: "0",
          tpCode: this.data.ARTICLE_DISCUSS_TYPE_CODE
          // sortProp: this.data.sortProp,
          // sortOrder: this.data.sortOrder,
        }
      };
      http
        .post(
          window.config.api.baseUrl + "/eims-api/share/approve/findApproveList",
          obj
        )
        .then(value => {
          if (value.data.code === "00000") {
            this.data.list = value.data.data.articles;
            this.data.total = value.data.data.total;
            this.data.userId = value.data.data.userId;
          }
        })
        .finally(() => {
          this.data.tableLoading = false;
        });
    },

    sort_change(column) {
      this.data.pageNum = 1;
      this.data.sortProp = column.prop;
      this.data.sortOrder = column.order;
      // if (column.order === 'ascending') {
      //   this.data.sortOrder = 'asc'
      // } else if (column.order === 'descending') {
      //   this.data.sortOrder = 'desc'
      // } else {
      //   this.data.sortorder = 'asc'
      // }

      this.data.list = this.data.list.sort((a, b) => {
        if (column.order === "descending") {
          return this.SortString(a[column.prop], b[column.prop], -1);
        } else if (column.order === "ascending") {
          return this.SortString(a[column.prop], b[column.prop], 1);
        }
        return 0;
      });
    },
    SortString(a, b, sortOrder) {
      if (typeof a === "string" && typeof b === "string") {
        return a.localeCompare(b) * sortOrder;
      } else if (typeof a === "number" && typeof b === "number") {
        return (a - b) * sortOrder;
      } else if (a instanceof Date && b instanceof Date) {
        return (a - b) * sortOrder;
      }
    },

    //查询已发布并审核通过的数据
    queryAllPublish() {
      this.count = 0;
      this.caseDiscussEs = [];
      this.lazyLoadingData(-1);
    },

    computedShowType(showDataType, flag) {
      return showDataType === flag ? "primary" : "cancel";
    },

    sensitiveWord(items) {
      this.$confirm("存在敏感词汇：" + items)
        .then(_ => {
          items();
        })
        .catch(_ => {});
    },

    scrollToTop() {
      // 获取点击那一刻的scrollTop值
      let scrollTop = document.documentElement.scrollTop;
      document.documentElement.style.transition = "200ms all";
      //1000可以说是多少毫秒完成的动作
      this.scrollTopStep = scrollTop / 100;
      let that = this;
      let t = setInterval(function() {
        // 缓动动画，每一次回滚原有指定的高度
        scrollTop -= that.scrollTopStep;
        // 自己定义临界值
        if (scrollTop <= 5) {
          clearInterval(t);
          scrollTop = 0;
        }
        document.documentElement.scrollTop = scrollTop;
      }, 1);
    },

    shareDiscuss(item) {
      // 创建输入框元素
      let oInput = document.createElement("input");
      // 将想要复制的值
      oInput.value =
        window.location.origin + "/#/forum/detail?id=" + item.postCode;
      // 页面底部追加输入框
      document.body.appendChild(oInput);
      // 选中输入框
      oInput.select();
      // 执行浏览器复制命令
      document.execCommand("Copy");
      // 弹出复制成功信息
      Message.success({ message: "分享链接已复制！", showClose: true });
      // 复制后移除输入框
      oInput.remove();
    },

    applyHandler(item) {
      this.applyForum = item;
      this.applyDialogVisible = true;
    },

    sureApplyHandler() {
      this.isLoading = true;
      let that = this;
      http
        .post(window.config.api.baseUrl + "/eims-api/discuss/apply", {
          token: cookie.getCookie("token"),
          data: {
            postCode: that.applyForum.postCode
          }
        })
        .then(response => {
          if (response.data.code === "00000") {
            Message.success({
              message: "您的信息已提交审核！",
              showClose: true
            });
          }
        })
        .finally(() => {
          this.applyDialogVisible = false;
          this.isLoading = false;
        });
    },

    initPage() {
      let obj = this.$store.state.searchConditionModule.condition.discuss;
      this.keyword = obj.keyword ? obj.keyword : null;

      let that = this;
      window.addEventListener("resize", this.timeOutChange);
      window.addEventListener("scroll", this.scroll);
      window.addEventListener("resize", this.calculateHeight);
      this.windowSizeChange();
      this.step = (24 / this.span) * 5;

      //需要将页面的 非 none的 transform去掉,否则会导致position:fixed;失效
      setTimeout(() => {
        let dom = document.getElementsByClassName("forum-list");
        try {
          dom[0].classList.remove("forum-list");
        } catch (e) {}
      }, 800);

      //将页面设置回到顶部
      scrollTo(0, 0);

      //-1是为使得第一添加框已经占位了,使得平齐
      that.lazyLoadingData(-1);
      if (this.$route.query.code) {
        this.dialog.postCode = this.$route.query.code;
      }
      let url = window.location.href;
      let index = url.indexOf("flag");
      let code = url.indexOf("code");
      if (index != -1 && code != -1) {
        this.discussPrevExp();
      }
    },

    scroll() {
      let that = this;
      setTimeout(() => {
        //变量scrollTop是滚动条滚动时，距离顶部的距离
        let scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        //变量windowHeight是可视区的高度
        let windowHeight =
          document.documentElement.clientHeight || document.body.clientHeight;
        //变量scrollHeight是滚动条的总高度
        let scrollHeight =
          document.documentElement.scrollHeight || document.body.scrollHeight;
        //滚动条到底部的条件(坑 这里前面的加和是小数,可能会导致判断结构不成立,需要改成 +n >= )
        if (scrollTop + windowHeight + 10 >= scrollHeight) {
          //写后台加载数据的函数
          that.lazyLoadingData();
        }

        let showScroll = document.getElementById("showScroll");
        if (document.documentElement.scrollTop >= 500) {
          showScroll.classList.remove("showScrollOut");
          showScroll.classList.add("showScroll");
        } else if (document.documentElement.scrollTop <= 500) {
          showScroll.classList.remove("showScroll");
          showScroll.classList.add("showScrollOut");
        }
      }, 100);
    },

    calculateHeight() {
      this.currentHeight = document.body.offsetHeight;
    },

    timeOutChange() {
      let that = this;
      if (this.spanTimeout !== null) {
        clearTimeout(that.spanTimeout);
        that.spanTimeout = null;
      }
      that.spanTimeout = setTimeout(() => {
        that.windowSizeChange();
      }, 10);
    },

    //窗口发生变化
    windowSizeChange() {
      let panel = document.getElementsByClassName("forum-panel")[0];
      this.span = generateStandardSpan(panel.offsetWidth, this.sensitive);
    },

    intoCaseDiscuss(item) {
      if (item.status === "1") {
        this.border = true;
        this.dialog.editFlag = "view";
        let scrollbarWidthSize = scrollbarWidth();
        let dom = document.getElementById("toBigDiv");
        dom.classList.add("toBigDiv");
        dom.style.width = `calc(10vw - ${scrollbarWidthSize / 10}px)`;
        dom.style.left = `calc(45vw - ${scrollbarWidthSize / 2}px)`;

        //执行完毕动画之后跳转下一个页面
        setTimeout(() => {
          this.$router.push({
            path: "/forum/detail",
            query: {
              id: item.postCode
            }
          });
        }, 200);
      } else {
        this.$router.push({
          path: "/forum/detail",
          query: {
            id: item.postCode,
            tmp: "1"
          }
        });
      }
    },

    startNewForum() {
      // this.$refs.forum.changeDialogStatus(true)
      this.postCreateVisible = true;
    },

    //懒加载数据方法
    lazyLoadingData(offset) {
      if (!this.lazyLoadingFinally) {
        //避免同时加载多个请求,出现数据重复出现的问题
        return;
      }
      this.lazyLoadingFinally = false;
      let that = this;

      that.loading = { flag: true };
      http
        .post(window.config.api.baseUrl + "/eims-api/discuss/list", {
          token: cookie.getCookie("token"),
          data: {
            keyword: this.form.keyword,
            timeRange: this.queryTimeRange,
            currentIndex: that.count,
            pageSize: that.step + that.revise + (offset || 0)
          }
        })
        .then(response => {
          let data = response.data.data;
          that.count += data.caseDiscussEs.length;
          //矫正之后将其置为0
          that.revise = 0;
          for (let item of data.caseDiscussEs) {
            that.caseDiscussEs.push(item);
          }
          this.loadingText = this.$options.data().loadingText;
          if (data.total <= that.count) {
            that.loading = { flag: false };
          }
        })
        .finally(() => {
          this.lazyLoadingFinally = true;
        });

      //设置为下拉加载更多数据
      that.loadingText = that.$options.data().loadingText;
      //获取dom节点将后面的...进度去掉
      let dom = document.getElementById("loadingTipText");
      try {
        dom.classList.remove("loadingText");
      } catch (e) {}
    },

    back() {
      this.$store.dispatch("clearDiscussCondition");
      this.$router.push({ path: "/home" });
    }
  }
};
</script>

<style lang="scss" scoped>
.forum-list {
  animation-duration: 800ms;
  animation-fill-mode: forwards;
  animation-name: forum-in;
}

.forum-list-content {
  margin: 20px;
  background-color: #fff;
  box-shadow: 1px 2px 5px #ccc;
  min-height: calc(100vh - 109px);
  .container-body {
    padding: 10px;
    .forum-panel {
      font-size: 0;
      text-align: center;
      .forum-card-create {
        text-align: center;
        vertical-align: top;
        transition-duration: 400ms;
        display: inline-block;
        margin: 10px 0;
        width: 100%;
        height: 370px;
        padding: 20px;
        border-radius: 8px;
        box-shadow: #dfe0e2 1px 10px 30px;
        &:hover {
          transition-duration: 400ms;
          cursor: pointer;
          box-shadow: #b4b5b6 1px 10px 30px;
        }
        .forum-card-create-up {
          background-image: url("/static/images/forum_add.jpg");
          background-size: cover;
          display: inline-block;
          width: 220px;
          height: 150px;
        }

        .forum-card-create-center {
          margin: 20px;
          padding: 0 30px;
          display: block;
          span {
            height: 35px;
            width: 100%;
            display: inline-block;
          }
          span:first-child {
            font-size: 18px;
            font-weight: bold;
          }
          span:nth-child(2) {
            font-size: 16px;
            color: #5c6168;
          }
        }

        .forum-card-create-bottom {
          text-align: center;
          .btn-start {
            font-size: 18px;
            padding: 2px 10px;
            border-color: transparent;
            border-radius: 5px;
            background-color: #3ad4ee;
            color: white;
            &:hover {
              background-color: #2ea1b4;
            }

            &:active {
              background-color: #278a9c;
            }
          }
        }
      }
      .forum-card-apply {
        width: 100%;
        position: relative;
        display: inline-block;
        margin: 10px 0;
        height: 370px;
        padding: 0;
        top: 3px;
        .forum-card-apply-up {
          border-radius: 20px 20px 0 0;
          position: relative;
          content: "";
          display: inline-block;
          width: inherit;
          top: -3px;
          height: 15px;
          background-color: rgb(251, 175, 87);
        }

        .forum-card-apply-down {
          transition-duration: 400ms;
          border: 0;
          top: -13px;
          position: relative;
          width: inherit;
          height: 365px;
          background-color: white;
          box-shadow: #dfe0e2 1px 10px 30px;
          border-radius: 8px;
          padding: 10px;
          &:hover {
            transition-duration: 400ms;
            cursor: pointer;
            box-shadow: #b4b5b6 1px 10px 30px;
          }
          .forum-card-top {
            height: 80px;
            .forum-card-avatar {
              border: 3px rgba(238, 244, 251, 0.8) solid;
              border-radius: 5px;
              margin: 10px;
              width: 56px;
              height: 56px;
              background-image: url("http://localhost:10001/eims-api/avatar/default_YIY0zDqSa20CZoE1WSzJ.jpg");
              background-size: cover;
              float: left;
            }
          }
          .forum-card-inner {
            height: 200px;
            .forum-card-title {
              display: inline-block;
              height: 52px;
              width: calc(100% - 20px);
              margin: 10px;
              span {
                word-wrap: break-word;
                white-space: normal;
                text-align: left;
                font-weight: bold;
                font-size: 20px;
                display: -webkit-box;
                /*设置文本只显示的行数*/
                -webkit-line-clamp: 2;
                /*设置文本显示纵向排版*/
                -webkit-box-orient: vertical;
                overflow: hidden;
              }
              span:hover {
                text-decoration-line: underline;
                color: #439fb1;
              }
            }
            .forum-card-content {
              text-align: left;
              font-size: 18px;
              color: #5c6168;
              /*将超出的文本隐藏*/
              overflow: hidden;
              /*设置文本超出span长度之需要设置为不换行*/
              white-space: nowrap;
              /*将溢出的文本使用...显示*/
              text-overflow: ellipsis;
              display: inline-block;
              margin: 0px 10px 10px 10px;
              height: 24px;
              width: calc(100% - 20px);
            }

            .forum-card-author {
              font-size: 18px;
              color: #8c939d;
              margin: 0 10px;
              margin-top: 10px;
              text-align: left;
              display: inline-block;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              width: calc(100% - 10px);
            }

            .forum-card-time {
              font-size: 18px;
              color: #8c939d;
              margin: 10px;
              text-align: left;
              display: inline-block;
              width: calc(100% - 10px);
            }
            .icon-caidanguanli:before {
              font-weight: bold;
              font-size: 20px;
              margin: 0px 5px;
              color: #3ad4ee;
            }
            .icon-rili:before {
              font-weight: bold;
              font-size: 20px;
              margin: 0px 5px;
              color: #3ad4ee;
            }
          }
          .forum-card-bottom {
            padding: 15px;
            height: 60px;
            button {
              font-size: 18px;
              padding: 2px 10px;
            }

            .btn-apply {
              border-color: transparent;
              border-radius: 5px;
              background-color: #3ad4ee;
              float: left;
              color: white;
              &:hover {
                background-color: #2ea1b4;
              }
              &:active {
                background-color: #278a9c;
              }
            }

            .btn-share {
              border: 1px #3ad4ee solid;
              border-radius: 5px;
              background-color: white;
              float: right;
              color: #3ad4ee;
              &:hover {
                background-color: #f1f1f1;
              }
              &:active {
                background-color: #dcdcdc;
              }
            }
          }
        }
      }
    }
    .table-card {
      margin: 20px 0;
      .eims-button {
        font-size: 16px;
        color: #409eff;
        border-color: transparent;
        background: transparent;
        white-space: nowrap;
        &:focus {
          outline: none;
        }
      }
    }
    .page {
      float: right;
    }
    #loadingTipText {
      cursor: pointer;
      display: block;
      text-align: center;
      color: #8c939d;
      &:hover {
        color: #676b74;
      }
    }
  }
  .toBigDiv {
    position: fixed;
    z-index: 99999;
    border: #8c939d 1px solid;
    height: calc(10vh);
    top: calc(45vh);
    background-color: white;
    -webkit-transform: scale(10);
    -ms-transition: all 200ms ease-in;
    -ms-transform: scale(10);
    -moz-transition: all 200ms ease-in;
    -moz-transform: scale(10);
    transition: all 200ms ease-in;
    transform: scale(10);
  }
  .icon-huidaodingbu:before {
    cursor: pointer;
    color: #ffffff;
    font-size: 30px;
    padding: 10px;
    line-height: 50px;
  }
}

@keyframes forum-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0);
  }
}

.loadingText::after {
  content: "";
  width: 3px;
  height: 3px;
  display: inline-block;
  animation-name: loadingText;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  color: #8c939d;
}

@keyframes loadingText {
  from {
    box-shadow: none;
  }
  30% {
    box-shadow: 3px 0 0 currentColor;
  }
  60% {
    box-shadow: 3px 0 0 currentColor, 9px 0 0 currentColor;
  }
  90% {
    box-shadow: 3px 0 0 currentColor, 9px 0 0 currentColor,
      15px 0 0 currentColor;
  }
}

#showScroll {
  left: calc(100vw + 50px);
  top: calc(90vh - 50px);
  position: fixed;
  display: inline-block;
  background-color: rgba(204, 204, 204, 0.5);
  z-index: 999;
  width: 50px;
  height: 50px;
  border-radius: 100%;
}

#search {
  left: calc(100vw + 50px);
  top: calc(90vh - 120px);
  position: fixed;
  display: inline-block;
  background-color: rgba(204, 204, 204, 0.5);
  z-index: 999;
  width: 50px;
  height: 50px;
  border-radius: 50px;
  padding: 10px;
}

.showScroll {
  width: 50px;
  height: 50px;
  left: calc(100vw + 50px);
  animation-name: showScrollAnimation;
  animation-duration: 400ms;
  animation-fill-mode: forwards;
}

@keyframes showScrollAnimation {
  100% {
    left: calc(100vw - 80px);
  }
}

.showScrollOut {
  left: calc(100vw - 80px);
  animation-name: showScrollAnimationOut;
  animation-duration: 400ms;
  animation-fill-mode: forwards;
}

@keyframes showScrollAnimationOut {
  100% {
    left: calc(100vw + 50px);
  }
}
/deep/.el-table--striped
  .el-table__body
  tr.el-table__row--striped
  td.el-table__cell {
  background: #f3fdff;
}
</style>



// WEBPACK FOOTER //
// src/pages/forum/ForumList.vue